export default class Comarca {
    constructor() {
        this.cd_ibge_comarca = '';
        this.cd_uf = '';
        this.ds_limite_diario = '';
        this.nm_municipio = '';
        this.name = '';
    }
}
